import { Component } from '@angular/core';
import {IonicPage, NavController} from 'ionic-angular';
import {ServerProvider} from "../../providers/server/server";

@IonicPage({
  name: 'cases',
  segment: 'cases'
})
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
  constructor( public server: ServerProvider, public navCtrl: NavController) {

  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts